import { Button, FormControl, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import SvgIconStyle from './SvgIconStyle';

interface EmailsInputProps {
  emails: string[];
  changeHandler: (emails: string[]) => void;
}

const EmailsInput = (props: EmailsInputProps) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {props.emails && (
        <Fragment>
          {props.emails.map((email: string, index: number) => {
            return (
              <FormControl key={index} style={{ width: '100%', marginBottom: '10px' }}>
                <TextField
                  style={{ maxWidth: '400px' }}
                  type="email"
                  value={email}
                  onChange={(event) => {
                    props.changeHandler(
                      props.emails.map((email, ind) => {
                        if (ind === index) return event.target.value;
                        return email;
                      })
                    );
                  }}
                />
              </FormControl>
            );
          })}
          <Button
            sx={{ color: '#003a5b', backgroundColor: 'white', height: 40, marginTop: '10px' }}
            variant={'outlined'}
            onClick={() => {
              props.changeHandler(props.emails.concat(''));
            }}
          >
            {t('add_email')}
            <SvgIconStyle
              src="/static/icons/giraf/on_new_data.svg"
              sx={{ width: '20px', height: '20px', display: 'block' }}
            />
          </Button>
        </Fragment>
      )}
    </Fragment>
  );
};

export default EmailsInput;
